// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyARMQkehlsMBB1YBfghqO69o1vrLr3US-c',
    authDomain: 'habits-tracker-9049c.firebaseapp.com',
    projectId: 'habits-tracker-9049c',
    storageBucket: 'habits-tracker-9049c.appspot.com',
    messagingSenderId: '285355040008',
    appId: '1:285355040008:web:be9ca1df8827b4445160bd',
  },
  custom: {
    firebaseRootDoc: 'local',
    firebaseDefaultConfigRoot: 'config'
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
